import Api from './Api';
import Configuracao from '../util/Configuracao';
import { parse } from 'date-fns';

class FaturaApi extends Api {
  async consultarTodasAsFaturasPorPrestadorOuCodigoFatura (seqPrestador, codFatura) {
    try {
      const consultarLotesPorPrestadorOuCodigoFatura = Configuracao.getConfiguracao().urlConsultarLotesPorPrestadorOuCodigoFatura + seqPrestador + '/fatura/' + codFatura;
      const response = await this.fetch(consultarLotesPorPrestadorOuCodigoFatura);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarFaturasPorPrestadorCodigoStatus (seqPrestador, numCarteiraTst = 'vazio', codFatura, numGuiaPrestador = 'vazio', numGuiaOperadora = 'vazio', txtSenhaAutorizacao = 'vazio', codEstado) {
    try {
      const consultarLotesPrestadorCodigoStatus = Configuracao.getConfiguracao().urlConsultarLotesPorPrestadorOuCodigoFatura + seqPrestador + '/numCarteiraTst/' + numCarteiraTst + '/fatura/' + codFatura + '/numGuiaPrestador/' + numGuiaPrestador + '/numGuiaOperadora/' + numGuiaOperadora + '/senha/' + txtSenhaAutorizacao + '/estado/' + codEstado;
      const response = await this.fetch(consultarLotesPrestadorCodigoStatus);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async consultarFaturasPorNumGuiaPrestador (numGuiaPrestador) {
    try {
      const urlConsultarFaturasPorNumGuiaPrestador = `${Configuracao.getConfiguracao().urlConsultarFaturasPorNumGuiaPrestador}/${numGuiaPrestador}`;
      const response = await this.fetch(urlConsultarFaturasPorNumGuiaPrestador);

      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async consultarLotesPorEstadoProtocolo (status) {
    try {
      const consultarLotesPorEstadoProtocoloUrl = Configuracao.getConfiguracao().urlConsultarLotesPorEstadoProtocolo + status;
      const response = await this.fetch(consultarLotesPorEstadoProtocoloUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async salvarDtaRecebimentoProcessoFisicoEmLote (codLoteGuias, data) {
    const urlSalvarDtaRecebimentoProcessoFisicoEmLote = Configuracao.getConfiguracao().urlSalvarDtaRecebimentoProcessoFisicoEmLote + 'receber_data_faturas/' + parse(data);
    const result = this.fetch(urlSalvarDtaRecebimentoProcessoFisicoEmLote, 'POST', codLoteGuias, { 'content-type': 'application/json' });
    return result;
  }

  async desfazerFaturasEmLote (codLoteGuias) {
    const url = Configuracao.getConfiguracao().urlDesfazerFaturasEmLote;
    const result = this.fetch(url, 'POST', codLoteGuias, { 'content-type': 'application/json' });
    return result;
  }

  async finalizarFaturasEmLote (codLoteGuias) {
    const url = Configuracao.getConfiguracao().urlFinalizarFaturasEmLote;
    const result = this.fetch(url, 'POST', codLoteGuias, { 'content-type': 'application/json' });
    return result;
  }

  async auditarAutomaticamenteFaturasEmLote (codLoteGuias) {
    const url = Configuracao.getConfiguracao().urlAuditarAutomaticamenteFaturasEmLote;
    const result = this.fetch(url, 'POST', codLoteGuias, { 'content-type': 'application/json' });
    return result;
  }
  async finalizarAvaliacaoFaturasCNU (codLoteGuias) {
    const url = Configuracao.getConfiguracao().urlFinalizarAvaliacaoFaturasCNU;
    const result = this.fetch(url, 'POST', codLoteGuias, { 'content-type': 'application/json' });
    return result;
  }
  async devolverFaturasTstEmLote (codLoteGuias) {
    const url = Configuracao.getConfiguracao().urlDevolverFaturasTstEmLote;
    const result = this.fetch(url, 'POST', codLoteGuias, { 'content-type': 'application/json' });
    return result;
  }
  async enviarFaturasCnuEmLote (codLoteGuias) {
    const url = Configuracao.getConfiguracao().urlEnviarFaturasCnuEmLote;
    const result = this.fetch(url, 'POST', codLoteGuias, { 'content-type': 'application/json' });
    return result;
  }
  async auditarFaturasEmLote (codLoteGuias) {
    const url = Configuracao.getConfiguracao().urlAuditarFaturasEmLote;
    const result = this.fetch(url, 'POST', codLoteGuias, { 'content-type': 'application/json' });
    return result;
  }

  async liberarFaturasEmLote (codLoteGuias) {
    const urlLiberarFaturasEmLote = Configuracao.getConfiguracao().urlLiberarFaturasEmLote;
    const result = await this.fetch(urlLiberarFaturasEmLote, 'POST', codLoteGuias, { 'content-type': 'application/json' });
    return result;
  }

  async negarAuditoriaEmLote (codLoteGuias) {
    const urlNegarAuditoriaEmLote = Configuracao.getConfiguracao().urlNegarAuditoriaEmLote;
    const result = this.fetch(urlNegarAuditoriaEmLote, 'POST', codLoteGuias, { 'content-type': 'application/json' });
    return result;
  }

  async cancelarFaturasEmLote (codLoteGuias, motivo) {
    const urlCancelarFaturasEmLote = Configuracao.getConfiguracao().urlCancelarFaturasEmLote + motivo;
    const result = this.fetch(urlCancelarFaturasEmLote, 'POST', codLoteGuias, { 'content-type': 'application/json' });
    return result;
  }

  async consultarLote (codLote) {
    const urlConsultarLote = `${Configuracao.getConfiguracao().urlConsultarLote}/${codLote}`;
    const result = this.fetch(urlConsultarLote);
    return result;
  }

  async excluirFaturasEmLote (codLoteGuias, cpfCnpj) {
    const urlExcluirFaturasEmLote = Configuracao.getConfiguracao().urlExcluirFaturasEmLote + cpfCnpj;
    const result = this.fetch(urlExcluirFaturasEmLote, 'POST', codLoteGuias, { 'content-type': 'application/json' });
    return result;
  }

  async consultarCodigoENumeroFaturas () {
    try {
      const urlCodigoENumeroFaturas = Configuracao.getConfiguracao().urlCodigoENumeroFaturas;
      const response = await this.fetch(urlCodigoENumeroFaturas);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
}

export default FaturaApi;
